<template>
  <div>
    <account-reference-header :stats="this.stats"/>
    <div class="flex" style="width: 100%">
      <account-references-left-panel v-if="this.isAdminUser"/>
      <div style="width: 100%">
        <div>
          <section class="dashwidget-row">
            <div id="otframe" class="dashwidget dashwidget-w-full">
              <div v-if="showReferencesMode === 'account'" class="widgettitle">
                Account References For {{ selectedAccount && selectedAccount.name }}
                <span @click.prevent="showHelpBubble" class="acclaro-icon ai-info clickable"></span>

              </div>
              <div v-else-if="showReferencesMode === 'assigned'" class="widgettitle">
                Assigned Account References
                <span @click.prevent="showHelpBubble" class="acclaro-icon ai-info clickable"></span>
              </div>
              <span v-if="references.length">
                <div class="widgetsubtitle">
                  <div id="othtab" class="widgettab grid" :class="tableColsClass">
                      <div>Name</div>
                      <div v-if="showReferencesMode === 'assigned'">Account</div>
                      <div>Posted By</div>
                      <div>Last Edited By</div>
                      <div>Last Updated</div>
                      <div>&nbsp;</div>
                  </div>
                </div>
                <div id="otvalue" class="widgetcontent scrolling dashwidget-table-rows" style="height: 300px">
                  <div id="references-container">
                    <div class="widgettab">
                      <div id="account-references-tbody">
                        <div :key="reference.id"
                             v-for="reference in this.references"
                             class="references-user-cols"
                             :class="[tableColsClass, getReferenceBgColor(reference)]">
                          <div class="reference-table-col"
                               :class="getReferenceBgColor(reference)">
                            <a class="clickable-blue"
                               title="View Reference"
                               @click.prevent="viewReference(reference)">
                              {{ reference.name }}
                            </a>
                          </div>
                          <div class="reference-table-col"
                               v-if="showReferencesMode === 'assigned'"
                               :class="getReferenceBgColor(reference)"
                          >
                            {{ reference.account_name }}
                          </div>
                          <div class="reference-table-col"
                               :class="getReferenceBgColor(reference)">
                            {{ reference.user_full_name }}
                          </div>
                          <div class="reference-table-col"
                               :class="getReferenceBgColor(reference)">
                            {{ reference.last_edited_by_full_name }}</div>
                          <div class="reference-table-col"
                               :class="getReferenceBgColor(reference)">
                            {{ reference.updated_at_formatted }}</div>
                          <div class="reference-table-col reference-table-col-actions"
                               :class="getReferenceBgColor(reference)">
                            <div class="flex justify-center">
                              <span class="flex">
                                <pencil-icon v-if="canEdit(reference)"
                                             title="Edit reference"
                                             @click="showEditModal(reference)"
                                             alt="Edit reference"
                                             class="reference-action-icon clickable cursor-pointer"
                                             fillColor="#0069AA"
                                             :size="18"/>
                              </span>
                              <span class="flex">
                                <trash-can-outline-icon
                                    v-if="reference.user_id === sessionUser.id"
                                    title="Delete reference"
                                    @click="handleDelete(reference.id)"
                                    class="reference-action-icon clickable cursor-pointer"
                                    alt="Delete reference"
                                    :size="18"
                                    fillColor="#0069AA"/>
                                <div class="flex" v-if="reference.user_id === sessionUser.id">
                                  <eye-off-icon v-if="reference.is_private"
                                                title="Make visible to account"
                                                @click="updatePrivacy(reference, 0)"
                                                alt="Share with account"
                                                class="reference-action-icon tt-cursor cursor-pointer"
                                                fillColor="#0069AA"
                                                :size="18"/>
                                  <eye-icon v-else
                                            title="Make private"
                                            @click="updatePrivacy(reference, 1)"
                                            alt="Make private"
                                            fillColor="#0069AA"
                                            class="reference-action-icon cursor-pointer"
                                            :size="18"/>
                                </div>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <account-references-pagination/>
                </div>
              </span>
              <account-references-no-data v-else :selected-account="selectedAccount"/>
            </div>
          </section>
          <account-references-form/>
          <acclaro-modal v-if="showReference" @close="closeShowReference">
            <div slot="header" class="account-references-preview-modal-header account-references-preview-modal-section">
              <div>
                <h2>{{ showingReference.name }}</h2>
              </div>
              <div>
                <div>
                  <i @click="closeShowReference" class="acclaro-icon ai-close clickable"></i>
                </div>
              </div>
            </div>
            <div slot="body"
                 class="account-references-preview-modal"
                 v-html="showingReference.details_html">
            </div>
            <div slot="footer">
<!--              <button-->
<!--                  class="bbutton"-->
<!--                  title="Share reference"-->
<!--                  @click="copyURL(showingReference)">-->
<!--                Get Link-->
<!--              </button>-->
              <button
                  class="bbutton"
                  @click="duplicateReference(showingReference)">
                Duplicate
              </button>
              <button class="button bbutton" @click="closeShowReference">
                Close
              </button>
            </div>
          </acclaro-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountReferencesNoData from "./AccountReferencesNoData";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import AccountReferencesForm from './AccountReferencesForm';
import AccountReferencesPagination from "./AccountReferencesPagination";
import AcclaroModal from './../Modal/acclaro-modal.vue';
import './references.scss';

import {
  PencilIcon,
  TrashCanOutlineIcon,
  EyeIcon,
  EyeOffIcon,
} from '../icons.js';

import AccountReferenceHeader from "./AccountReferenceHeader";
import AccountReferencesLeftPanel from "./AccountReferencesLeftPanel";

export default {
  name: "account-references.vue",
  props: {
    referenceId: String,
  },
  components: {
    AccountReferencesLeftPanel,
    AccountReferenceHeader,
    AccountReferencesForm,
    AccountReferencesNoData,
    PencilIcon,
    AcclaroModal,
    TrashCanOutlineIcon,
    EyeIcon,
    EyeOffIcon,
    AccountReferencesPagination
  },
  mounted () {
    this.setSelectedAccount(this.sessionAccount);
    // show single reference's popup if provided via prop
    if (this.referenceId) {
      this.setSearchTerm(this.referenceId);
      this.fetchReferences(this.requestUrl);
    }
    else {
      this.fetchReferences(this.requestUrl);
    }
  },
  computed: {
    ...mapState('AccountReferencesStore', [
      'references',
      'stats',
      'referenceDetailsModal',
      'editingReference',
      'selectedAccount',
      'showReferencesMode',
      'showingReference',
      'showReference',
    ]),
    ...mapState("UserDataStore", [
      "accountList",
    ]),
    ...mapGetters('AuthStore', [
      'isAdminUser'
    ]),
    ...mapState('AuthStore', {
      sessionUser: 'user',
      sessionAccount: 'account',
    }),
    ...mapGetters('AccountReferencesStore', [
      'requestUrl'
    ]),
    tableColsClass () {
      return this.showReferencesMode === 'account' ? 'references-user-cols' : 'references-admin-cols';
    }
  },
  methods: {
    ...mapMutations('AccountReferencesStore', [
      'setSearchTerm',
      'updateReferenceModalShow',
      'setEditingReference',
      'updateReferenceModalReferenceId',
      'updateReferenceModalMode',
      'updateReferenceModalName',
      'updateReferenceModalMode',
      'updateReferenceModalDetails',
      'updateReferenceModalIsPrivate',
      'updateReferenceModalAccountId',
      'clearReferenceModal',
      'setSelectedAccount',
      'setViewReference',
    ]),
    ...mapActions('AccountReferencesStore', [
      'fetchReferences',
      'patchReference',
      'deleteReference',
      'postReference'
    ]),
    ...mapMutations("UserDataStore", [
      "setUser",
      "setAccount",
      "setUserList",
      "setAccountList",
    ]),
    showEditModal (reference) {
      this.setEditingReference(reference);
      this.updateReferenceModalMode('edit');
      this.updateReferenceModalReferenceId(reference.id);
      this.updateReferenceModalAccountId(reference.account_id);
      this.updateReferenceModalIsPrivate(reference.is_private);
      this.updateReferenceModalName(reference.name);
      this.updateReferenceModalDetails(reference.details_html);
      this.updateReferenceModalShow(true);
    },
    canEdit (reference) {
      return this.isAdminUser || this.sessionAccount.id === reference.account_id;
    },
    stripTagsForPreview (html, ...args) {
      return html.replace(/<(\/?)(\w+)[^>]*\/?>/g, (_, endMark, tag) => {
        return args.includes(tag) ? '<' + endMark + tag + '>' : '';
      }).replace( /<!--.*?-->/g, '');
    },
    handleDelete (referenceId) {
      if (confirm("Are you sure you want to delete this reference?")) {
        this.deleteReference(referenceId);
      }
    },
    updatePrivacy (reference, value) {
      this.patchReference({
        "reference_id": parseInt(reference.id),
        "account_id": parseInt(reference.account_id),
        "is_private": value,
      });
    },
    closeShowReference () {
      this.setViewReference(undefined);
    },
    viewReference (reference) {
      this.setViewReference(reference);
    },
    getReferenceBgColor (reference) {
      return reference.is_private ? 'pink-bg' : 'white-bg';
    },
    showHelpBubble () {
      showPopupPage('account-references-help', 'Account References Help');

    },
    duplicateReference (reference) {
      this.closeShowReference();
      this.setEditingReference(reference);
      this.updateReferenceModalMode('duplicate');
      this.updateReferenceModalReferenceId(reference.id);
      this.updateReferenceModalAccountId(reference.account_id);
      this.updateReferenceModalIsPrivate(reference.is_private);
      this.updateReferenceModalName(reference.name + " (Copy)");
      this.updateReferenceModalDetails(reference.details_html);
      this.updateReferenceModalShow(true);
    },
    copyURL (reference) {
      const el = document.createElement('textarea');
      el.value = new URL(window.location.origin + `/references/portal/${reference.id}`).href;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Share link copied to clipboard!');
    }
  },
};
</script>
